import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { RatingsAndReviewsPropTypes } from './RatingsAndReviewsPropTypes';
import { RatingsAndReviewsPlaceholder } from './RatingsAndReviewsPlaceholder';
import { dataModel } from './ReviewDataModel';
import { RatingsAndReviewsDesktop as RatingsAndReviewsDesktopSSR } from './RatingsAndReviewsDesktop?clientSideRemove';

const placeholder = (
  <RatingsAndReviewsPlaceholder
    color="#E0E0E0"
    showLoadingAnimation
  />
);

const ImportedComponent = withDynamicImport({
  server: () => {
    // For Vite SSR - return the conditionally imported component
    return RatingsAndReviewsDesktopSSR;
  },
  client: () => {
    return import('./RatingsAndReviewsDesktop');
  },
  placeholder,
  name: 'RatingsAndReviewsDesktop'
});

const HydratedComponent = withHydrator({
  delay: 2000,
  id: 'product-section-rr',
  placeholder,
  preserveCtxVal: 'clientStore',
  scrollBuffer: 750
}, ImportedComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);

export const RatingsAndReviewsDesktopImporter = withErrorBoundary(DynamicComponent);

RatingsAndReviewsDesktopImporter.displayName = 'RatingsAndReviewsDesktopImporterVite';
RatingsAndReviewsDesktopImporter.propTypes = RatingsAndReviewsPropTypes;
RatingsAndReviewsDesktopImporter.dataModel = dataModel;